// extracted by css-extract-rspack-plugin
export default {"container":"FreeChatExceededBanner-module__container__M4eYi"};